module.exports = __webpack_public_path__ + "fonts/icomoon.3584462.eot";